import { Authentication } from './Authentication';
export class OAuth extends Authentication {
    constructor(context, tokenProvider) {
        super();
        this.context = context;
        this.tokenProvider = tokenProvider;
        this.accessToken = '';
    }
    async applyToRequest(requestOptions) {
        // TODO: ADD logic to deal with expired tokens
        // if (!this.accessToken) {
        // }
        const accessToken = await this.tokenProvider.getToken(this.context);
        if (requestOptions && requestOptions.headers && accessToken) {
            requestOptions.headers['Authorization'] = 'Bearer ' + accessToken;
        }
    }
}
//# sourceMappingURL=OAuth.js.map